import React from "react";
import { connect } from "react-redux";
import {
  userInRole,
  userInRoles,
  UserRoleTypeEnum
} from "../services/authService";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import ListSubheader from "@material-ui/core/ListSubheader";
import List from "@material-ui/core/List";
import AccountIcon from "@material-ui/icons/AccountBalance";
import DepartmentIcon from "@material-ui/icons/Dns";
import CompanyIcon from "@material-ui/icons/AccountBox";
import StrategyIcon from "@material-ui/icons/Assessment";
import ScenarioIcon from "@material-ui/icons/ViewList";
import CustomAccountIcon from "@material-ui/icons/ImportContacts";
import ImportIcon from "@material-ui/icons/LibraryAdd";
import HistoryIcon from "@material-ui/icons/History";
import { Divider } from "@material-ui/core";
import NavItem from "./NavItem";

const styles = theme => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper
  },
  nested: {
    paddingLeft: theme.spacing.unit * 4
  }
});

class NavList extends React.Component {
  render() {
    const { classes, open, user } = this.props;

    return (
      <List
        component="nav"
        subheader={
          open && userInRole(user, UserRoleTypeEnum.Administrator) ? (
            <ListSubheader component="div">Data Management</ListSubheader>
          ) : (
            undefined
          )
        }
        className={classes.root}
      >
        <NavItem
          path="/data/account"
          icon={AccountIcon}
          title="Accounts"
          requiredRoles={[
            UserRoleTypeEnum.Administrator,
            UserRoleTypeEnum.ReadOnly
          ]}
        />
        <NavItem
          path="/data/company"
          icon={CompanyIcon}
          title="Companies"
          requiredRoles={[
            UserRoleTypeEnum.Administrator,
            UserRoleTypeEnum.ReadOnly
          ]}
        />
        <NavItem
          path="/data/department"
          icon={DepartmentIcon}
          title="Departments"
          requiredRoles={[
            UserRoleTypeEnum.Administrator,
            UserRoleTypeEnum.ReadOnly
          ]}
        />
        <NavItem
          path="/data/scenario"
          icon={ScenarioIcon}
          title="Scenarios"
          requiredRoles={[
            UserRoleTypeEnum.Administrator,
            UserRoleTypeEnum.ReadOnly
          ]}
        />
        <NavItem
          path="/data/strategy"
          icon={StrategyIcon}
          title="Strategies"
          requiredRoles={[
            UserRoleTypeEnum.Administrator,
            UserRoleTypeEnum.ReadOnly
          ]}
        />
        {userInRoles(user, [
          UserRoleTypeEnum.Administrator,
          UserRoleTypeEnum.ReadOnly
        ]) ? (
          <Divider />
        ) : null}
        {open &&
        userInRoles(user, [
          UserRoleTypeEnum.Administrator,
          UserRoleTypeEnum.ReadOnly
        ]) ? (
          <ListSubheader>Account Management</ListSubheader>
        ) : (
          undefined
        )}
        <NavItem
          path="/account/custom"
          icon={CustomAccountIcon}
          title="Custom Accounts"
          requiredRoles={[
            UserRoleTypeEnum.Administrator,
            UserRoleTypeEnum.ReadOnly
          ]}
        />

        {userInRole(
          user,
          UserRoleTypeEnum.Administrator,
          UserRoleTypeEnum.ReadOnly
        ) ? (
          <Divider />
        ) : null}
        {open &&
        userInRoles(user, [
          UserRoleTypeEnum.Administrator,
          UserRoleTypeEnum.TransactionEntry,
          UserRoleTypeEnum.ReadOnly
        ]) ? (
          <ListSubheader>Transactions</ListSubheader>
        ) : (
          undefined
        )}
        <NavItem
          path="/transaction/import"
          icon={ImportIcon}
          title="Import"
          requiredRoles={[
            UserRoleTypeEnum.Administrator,
            UserRoleTypeEnum.TransactionEntry
          ]}
        />
        <NavItem
          path="/transaction/history"
          icon={HistoryIcon}
          title="History"
          requiredRoles={[
            UserRoleTypeEnum.Administrator,
            UserRoleTypeEnum.TransactionEntry,
            UserRoleTypeEnum.ReadOnly
          ]}
        />
      </List>
    );
  }
}

NavList.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    user: state.user.user
  };
}

export default connect(mapStateToProps)(withStyles(styles)(NavList));
